import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Box, Typography, Button } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';

/**
 * AccessDenied page component
 * Displays a user-friendly message when a user attempts to access a resource they don't have permission for
 */
const AccessDenied: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <LockIcon
          sx={{
            fontSize: 80,
            color: 'error.main',
            marginBottom: 2,
          }}
        />
        
        <Typography component="h1" variant="h4" gutterBottom>
          Access Denied
        </Typography>
        
        <Typography variant="body1" color="text.secondary" paragraph>
          You do not have permission to access this page. This resource requires specific roles or permissions that are not assigned to your account.
        </Typography>
        
        <Typography variant="body2" color="text.secondary" paragraph>
          If you believe you should have access to this page, please contact your system administrator.
        </Typography>
        
        <Box sx={{ marginTop: 3 }}>
          <Button
            component={Link}
            to="/"
            variant="contained"
            color="primary"
            size="large"
          >
            Return to Home
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default AccessDenied;
